module.exports = __webpack_public_path__ + "static/media/iv_upload_attachment.14878d5c.svg";